<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area company">
      <img
        :src="`${resources}img/img-top-sub-title.png`"
        alt=""
        v-if="device === 'mo'"
      />
      <div class="tit_area">
        <div class="sub_tit">CEO 인사말 입니다</div>
        <div class="sub_txt">
          기업의 성장과 가치 실현<br />미래를 함께하는 Best Partner을 만들어
          나가겠습니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <div class="company_item" v-if="device === 'mo'">
        <div class="company_tit">
          <strong
            >PC시장의 선도기업 한국오션플랫폼이 종합 솔루션 건설사로 도약하고자
            합니다.</strong
          >
        </div>

        <div class="company_txt">
          한국오션플랫폼은 1971년 설립되어 PC(Precast Concrete) 설계, 제작, 시공
          등
          <br />
          우리나라 PC 건설공법의 선진화를 이끌며 국내 PC건설 1위 기업으로
          성장해왔습니다.<br /><br />
          아시아 최대 규모의 첨단 자동화 PC 생산 라인을 구축하고, 지속적으로
          품질 인프라를 개선하여 고객 만족을 실현하는 선도 기업으로 그 자리를
          지키고 있습니다.<br />
          50년간 주거, 상업, 레저, 문화, 제조 등 다양한 건설 분야에서 괄목할만한
          성취를 이뤄온 한국오션플랫폼은 이제 변화와 도전의 4차 산업혁명 시대를
          맞아 더 큰 미래를 그립니다.<br /><br />
          PC 건설 시장을 주도하는 한편 공간 창조 이상의 가치를 실현하는 건축,
          인프라 건설, 복합개발 등 다양한 분야를 아우르는 종합 솔루션 건설사로
          도약하여 지속적으로 고객 가치를 창출하고 더 편리하고 아름다운 공간을
          창조하는데 기여하고자 합니다.<br /><br />
          새로운 미래를 향해 도전하는 한국오션플랫폼의 여정에 함께해 주시기
          바랍니다.
        </div>

        <div class="company_sign">
          <img :src="`${resources}img/invalid-name.png`" alt="천성복 사인" />
          대표이사 천성복
        </div>
      </div>
      <div class="company_item" v-else>
        <div class="company_tit1">
          PC시장의 선도기업<br />한국오션플랫폼이 종합 솔루션<br />건설사로
          도약하고자 합니다.
        </div>

        <div class="company_txt2">
          한국오션플랫폼은 1971년 설립되어 PC(Precast Concrete) 설계, 제작, 시공
          등
          <br />
          우리나라 PC 건설공법의 선진화를 이끌며 국내 PC건설 1위 기업으로
          성장해왔습니다.<br /><br />
          아시아 최대 규모의 첨단 자동화 PC 생산 라인을 구축하고, 지속적으로
          품질 인프라를 개선하여 고객 만족을 실현하는 선도 기업으로 그 자리를
          지키고 있습니다.<br />
          50년간 주거, 상업, 레저, 문화, 제조 등 다양한 건설 분야에서 괄목할만한
          성취를 이뤄온 한국오션플랫폼은 이제 변화와 도전의 4차 산업혁명 시대를
          맞아 더 큰 미래를 그립니다.<br /><br />
          PC 건설 시장을 주도하는 한편 공간 창조 이상의 가치를 실현하는 건축,
          인프라 건설, 복합개발 등 다양한 분야를 아우르는 종합 솔루션 건설사로
          도약하여 지속적으로 고객 가치를 창출하고 더 편리하고 아름다운 공간을
          창조하는데 기여하고자 합니다.<br /><br />
          새로운 미래를 향해 도전하는 한국오션플랫폼의 여정에 함께해 주시기
          바랍니다.
          <div class="company_sign">
            <img :src="`${resources}img/invalid-name.png`" alt="천성복 사인" />
            대표이사 천성복
          </div>
        </div>
      </div>
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';
export default {
  mixins: [page],
  mounted() {
    this.initTween();
  }
};
</script>

<style lang="scss" scoped></style>
